import httpClient from "./httpClient";

export default {
  async tourshirt() {
    const response = await httpClient({
      url: `/reports/tourshirt`,
      method: "get",
      responseType: "blob"
    });
    return response.data;
  },

  async bikehire() {
    const response = await httpClient({
      url: `/reports/bikehire`,
      method: "get",
      responseType: "blob"
    });
    return response.data;
  },

  async globalrescue(params) {
    const response = await httpClient({
      url: `/reports/globalrescue`,
      method: "get",
      responseType: "blob",
      params
    });
    return response.data;
  },

  async sales(params) {
    const response = await httpClient({
      url: `/reports/sales`,
      method: "get",
      params
    });
    return response.data;
  },

  async departures(params) {
    const response = await httpClient({
      url: `/reports/departures`,
      method: "get",
      params
    });
    return response.data;
  },

  async overdue(params) {
    const response = await httpClient({
      url: `/reports/overdue`,
      method: "get",
      params
    });
    return response.data;
  },

  async abtot(params) {
    const response = await httpClient({
      url: `/reports/abtot`,
      method: "get",
      params
    });
    return response.data;
  },

  download(fileData, fileName) {
    let fileURL = window.URL.createObjectURL(new Blob([fileData]));
    let fileLink = document.createElement("a");
    fileLink.href = fileURL;
    fileLink.setAttribute("download", fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);
  }
};
